/**
 * Try to use separate files in /components/
 *
 * IMPORTANT: If you want to use jQuery, make sure you enqueue it first.
 * Since it is only registered in actions.php
 */

import './components/sticky-nav';
import './components/offcanvas';
import './components/delay-search-queries';
import './components/video';
import './components/sidebar-anchors';
import './components/footer-menus';
import './components/accordion';
import { strlAddReadspeaker } from './helpers';

document.addEventListener('DOMContentLoaded', () => {
	strlAddReadspeaker(10152);
});
